import React from 'react';
import { IAnalyticsDimensionsProps } from '../../tracking/interfaces';
import {
    DisabledComponentsTypes,
    DisabledFunctionsTypes,
    ICaptchaProps,
    IHeaderProps,
    ILogInConfigMethodsProps,
    ILookUpConfigMethodsProps,
    IPasswordlessConfigMethodsProps,
    IRequestProps,
    ISignupConfigMethodsProps,
    ISocialConfigProps,
    ISocialLoginConfigMethodsProps,
    IToSConfigMethodsProps,
} from './interfaces';

export interface IConfigContextProps {
    disabledComponents?: DisabledComponentsTypes[];
    disabledFunctions?: DisabledFunctionsTypes[];
    header?: IHeaderProps;
    lookupMethods?: ILookUpConfigMethodsProps;
    loginMethods?: ILogInConfigMethodsProps;
    socialMethods?: ISocialLoginConfigMethodsProps;
    tosMethods?: IToSConfigMethodsProps;
    signupMethods?: ISignupConfigMethodsProps;
    passwordlessMethods?: IPasswordlessConfigMethodsProps;
    forgotPasswordMethods?: any;
    analytics: IAnalyticsDimensionsProps;
    captcha: ICaptchaProps;
    request?: IRequestProps;
    social?: ISocialConfigProps;
    featureFlags?: { [x: string]: boolean };
    fp?: string;
    forward?: string;
    referrer?: string;
    pckg?: string;
    isCheckoutAuthenticationFlow?: boolean;
    hideDivider?: boolean;
    showBackButton?: boolean;
    isUsingOrderId?: boolean;
}

export const useConfigContext = () => {
    const value = React.useContext(ConfigContext);

    if (!value) {
        throw new Error('useConfigContext must be used within ContextProvider');
    }

    return value;
};

const ConfigContext = React.createContext<any>(null);

const ConfigContextProvider = ({
    children,
    value,
}: {
    children: any;
    value: IConfigContextProps;
}) => {
    return (
        <ConfigContext.Provider value={value}>
            {children}
        </ConfigContext.Provider>
    );
};

export default {
    Context: ConfigContext,
    Consumer: ConfigContext.Consumer,
    Provider: ConfigContextProvider,
};
